module.exports = __webpack_public_path__ + "media/images/icons/building-eb36c94fded48c1813c9816180a4aba1.svg";